import React from "react";

const bg = `${EASYCOMMERCE.assets}admin/img/icons/bg.png`;

const Store = ({ formValues, setFormValues }) => {
    const pageFields = [
        { name: "shop",      label: "Shop Page"      },
        { name: "checkout",  label: "Checkout Page"  },
        { name: "dashboard", label: "Dashboard Page" },
    ];

    return (
        <div
            className="bg-cover bg-center w-full flex flex-col items-center"
            style={{
                backgroundImage: `url(${bg})`,
                backgroundSize: "1100px",
                backgroundRepeat: "no-repeat",
            }}
        >
            <div className="w-[40%] bg-white flex flex-col p-10 border-2 border-[#E0E8FF] rounded-xl">
                <div className="flex flex-col w-full space-y-6">
                    <div className="border border-ec-border p-6 rounded">
                        <label className="text-ec-body text-[16px] font-medium">
                            Pages
                        </label>
                        <p className="text-ec-placeholder text-xs mt-2">
                            Choose the pages you want to configure.
                        </p>
                        <div className="flex flex-col space-y-4 mt-6">
                            {pageFields.map(({ name, label }) => (
                                <div key={name} className="flex flex-col space-y-2">
                                    <label className="text-ec-body text-[14px] font-medium">
                                        {label}
                                    </label>
                                    <select
                                        className="easycommerce-wizard-input w-full"
                                        name={`general-store-${name}`}
                                        value={formValues[name] || ""}
                                        onChange={(e) =>
                                            setFormValues((prev) => ({
                                                ...prev,
                                                [name]: e.target.value,
                                            }))
                                        }
                                    >
                                        <option value="create">- Create New Page -</option>
                                        {Object.keys(EASYCOMMERCE.pages).map((pageId) => (
                                            <option key={pageId} value={pageId}>
                                                {EASYCOMMERCE.pages[pageId]}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            ))}
                        </div>
                    </div>
                     {/* import demo products */}
                    {/* <div className="border border-ec-border p-6 rounded">
                        <label className="text-ec-body text-[16px] font-medium">
                            Demo Products
                        </label>
                        <p className="text-ec-placeholder text-xs mt-2 mb-6">
                            Import Demo Products
                        </p>
                        <div className="flex flex-col space-y-4">
                            <div className="flex items-center space-x-2">
                                <input
                                    type="checkbox"
                                    id="demoProducts"
                                    checked={storeData.import_demo}
                                    onChange={() =>
                                        dispatch(
                                            updateFormData({
                                                key: "import_demo",
                                                value: !storeData.import_demo,
                                            })
                                        )
                                    }
                                    className="easycommerce-checkbox-input relative pointer checked:bg-ec-primary"
                                />
                                <label
                                    htmlFor="demoProducts"
                                    className="text-ec-secondary text-[16px]"
                                >
                                    I want to Import Demo Product
                                </label>
                            </div>
                        </div>
                    </div> */}
                </div>
            </div>
        </div>
    );
};

export default Store;
